import { render, staticRenderFns } from "./MessageProcessRules.vue?vue&type=template&id=d9cd1c8c"
import script from "./MessageProcessRules.vue?vue&type=script&lang=js"
export * from "./MessageProcessRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports